/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Restrict referenced related_operations to identifier indexes < the current operation_identifier.index. This ensures there exists a clear DAG-structure of relations. Since operations are one-sided, one could imagine relating operations in a single transfer or linking operations in a call tree.
 * @export
 * @interface RosettaRelatedOperation
 */
export interface RosettaRelatedOperation {
    /**
     * Describes the index of related operation.
     * @type {number}
     * @memberof RosettaRelatedOperation
     */
    index: number;
    /**
     * Some blockchains specify an operation index that is essential for client use. network_index should not be populated if there is no notion of an operation index in a blockchain (typically most account-based blockchains).
     * @type {number}
     * @memberof RosettaRelatedOperation
     */
    network_index?: number;
}

export function RosettaRelatedOperationFromJSON(json: any): RosettaRelatedOperation {
    return RosettaRelatedOperationFromJSONTyped(json, false);
}

export function RosettaRelatedOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaRelatedOperation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'network_index': !exists(json, 'network_index') ? undefined : json['network_index'],
    };
}

export function RosettaRelatedOperationToJSON(value?: RosettaRelatedOperation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'network_index': value.network_index,
    };
}

